import React from 'react';
import KeyRevocation from './components/KeyRevocation';

const KeyRevocationPage: React.FC = () => {
  // Title is set at the application level
  return <KeyRevocation />;
};

export default KeyRevocationPage;